import * as t from 'io-ts';
import * as WP from './withPose';
import { ModaSofa } from '@dora/backpack';

const optionals = t.partial({
    interstitialPlacements: ModaSofa.Interstitials,
    configurableProperties: t.partial({
        rattan_colour: t.type({ name: t.string, colour: t.string, image: t.string }),
    }),
    cornerStyle: ModaSofa.CornerStyle,
});

/**
 * modular moda furniture for a Layout document
 */
export const LayoutModularFurniture = t.intersection([
    WP.WithPose,
    t.type({
        shape: t.keyof({ corner: null, straight: null, 'u-shape': null }),
        size: t.type({ left: t.number, right: t.number, middle: t.number }),
    }),
    optionals,
]);

export type LayoutModularFurnitureT = t.TypeOf<typeof LayoutModularFurniture>;

function eqSize(
    left: { left: number; right: number; middle: number },
    right: { left: number; right: number; middle: number },
): boolean {
    return left.left === right.left && left.middle === right.middle && left.right === right.right;
}

/**
 * modular furniture is equal if they share a pose, shape, and size
 */
export function eq(left: LayoutModularFurnitureT, right: LayoutModularFurnitureT) {
    return WP.eq(left, right) && left.shape === right.shape && eqSize(left.size, right.size);
}
